
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {IdempotencyInfoDeleteResponse} from './IdempotencyInfoDeleteResponse';

/**
 * IdempotencyInfoDeleteRequest struct
 */
class IdempotencyInfoDeleteRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Array=} hashes
   * @constructor
   */
  constructor (parent = new Request(), hashes = []) {
    super()
    super.copy(parent)
    this.Hashes = hashes
  }

  /**
   * Copy struct (shallow copy)
   * @this {!IdempotencyInfoDeleteRequest}
   * @param {!IdempotencyInfoDeleteRequest} other Other struct
   * @returns {!IdempotencyInfoDeleteRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Hashes != null) {
      this.Hashes = []
      for (let item of other.Hashes) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Hashes.push(tempItem)
        } else {
          this.Hashes.push(null)
        }
      }
    } else {
      this.Hashes = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!IdempotencyInfoDeleteRequest}
   * @returns {!IdempotencyInfoDeleteRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new IdempotencyInfoDeleteRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new IdempotencyInfoDeleteRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!IdempotencyInfoDeleteRequest}
   * @param {!IdempotencyInfoDeleteRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof IdempotencyInfoDeleteRequest)) {
      throw new TypeError('Instance of IdempotencyInfoDeleteRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!IdempotencyInfoDeleteRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Hashes: ((this.Hashes != null) ? Array.from(this.Hashes, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return IdempotencyInfoDeleteRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!IdempotencyInfoDeleteRequest} other Object value
   * @returns {!IdempotencyInfoDeleteRequest} Created struct
   */
  static fromObject (other) {
    return new IdempotencyInfoDeleteRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!IdempotencyInfoDeleteRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return IdempotencyInfoDeleteRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!IdempotencyInfoDeleteRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4232
  }
}

export { IdempotencyInfoDeleteRequest };

/**
 * Fast Binary Encoding IdempotencyInfoDeleteRequest field model
 */
class FieldModelIdempotencyInfoDeleteRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Hashes = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Hashes.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Hashes.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelIdempotencyInfoDeleteRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4232
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Hashes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Hashes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Hashes.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!IdempotencyInfoDeleteRequest} fbeValue Default value, defaults is new IdempotencyInfoDeleteRequest()
   * @returns {!IdempotencyInfoDeleteRequest} IdempotencyInfoDeleteRequest value
   */
  get (fbeValue = new IdempotencyInfoDeleteRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!IdempotencyInfoDeleteRequest} fbeValue IdempotencyInfoDeleteRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Hashes.fbeSize) <= fbeStructSize) {
      this.Hashes.get(fbeValue.Hashes)
    } else {
      fbeValue.Hashes.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Hashes.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {!IdempotencyInfoDeleteRequest} fbeValue IdempotencyInfoDeleteRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelIdempotencyInfoDeleteRequest}
   * @param {IdempotencyInfoDeleteRequest} fbeValue IdempotencyInfoDeleteRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Hashes.set(fbeValue.Hashes)
  }
}

export { FieldModelIdempotencyInfoDeleteRequest };

/**
 * Fast Binary Encoding IdempotencyInfoDeleteRequest model
 */
class IdempotencyInfoDeleteRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelIdempotencyInfoDeleteRequest(this.buffer, 4)
  }

  /**
   * Get the IdempotencyInfoDeleteRequest model
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!FieldModelIdempotencyInfoDeleteRequest} model IdempotencyInfoDeleteRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return IdempotencyInfoDeleteRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelIdempotencyInfoDeleteRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @param {!IdempotencyInfoDeleteRequest} value IdempotencyInfoDeleteRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @param {!IdempotencyInfoDeleteRequest} value IdempotencyInfoDeleteRequest value, defaults is new IdempotencyInfoDeleteRequest()
   * @return {!object} Deserialized IdempotencyInfoDeleteRequest value and its size
   */
  deserialize (value = new IdempotencyInfoDeleteRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new IdempotencyInfoDeleteRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new IdempotencyInfoDeleteRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!IdempotencyInfoDeleteRequestModel}
   * @param {!number} prev Previous IdempotencyInfoDeleteRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { IdempotencyInfoDeleteRequestModel };
IdempotencyInfoDeleteRequest.__has_response = true;
IdempotencyInfoDeleteRequest.__response_class = IdempotencyInfoDeleteResponse;
